<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card  p-shadow-1">
				<h5>Cliente App</h5>
                <hr>

				<Toolbar class="p-mb-4">
					<template slot="left">							
						<Dropdown v-model="dispositivoSelecionado" :options="dispositivos" optionLabel="name" optionValue="valor" 
							class="p-mr-5" @change="listar" placeholder="Selecione"/>					
						<SplitButton label="Novo" icon="pi pi-plus" :model="items" ></SplitButton>					
					</template>
				</Toolbar>							

				<DataTable :value="clientesApp" :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-end">				
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>
					<Column field="clienteApp" header="Descrição" sortable></Column>
					<Column field="detalhes" header="Detalhes" sortable></Column>	
					<Column field="nome" header="Nome" sortable></Column>
					<Column field="login" header="Login" sortable></Column>	
					<Column field="dataUltimoRefresh" header="Último Acesso" sortable>		
						<template #body="slotProps">
							{{ slotProps.data.dataUltimoRefresh | dateHoraPtBR }}
						</template>				
					</Column>	
					<Column>
						<template #body="slotProps">
							<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" v-if="permissaoEditar"/>
							<Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="confirmarExcluir(slotProps.data)" v-if="permissaoExcluir"/>
						</template>
					</Column>			
				</DataTable>
				
				<Dialog :visible.sync="exibirDialogCadastroDeskTop" :header="'Criar Usuário Desktop'" :modal="true" class="p-fluid" :style="{width: '500px'}">			
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field p-col-12 p-md-12">
							<label for="descricao">Empresa</label>
							<Dropdown v-model.number="cnpjSelecionado" :options="cnpjs" optionLabel="razaoSocial" optionValue="id" placeholder="Selecione"/>							
						</div>										
					</div>
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field p-col-12 p-md-12">
							<label for="descricao">Número de série</label>							
							<Textarea v-model.trim="detalhes" rows="5" cols="30" required="true" placeholder="Informe o número de série separado por vírgula"/>
							<small class="p-invalid" v-if="enviandoForm && !detalhes">Detalhes</small>
						</div>	
					</div>									
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
						<Button label="Salvar" icon="pi pi-check" @click="criarUsuarioDesktop"/>
					</template>
				</Dialog>

				<Dialog :visible.sync="exibirDialogCadastroMobile" :header="'Criar Usuário Mobile'" :modal="true" class="p-fluid" :style="{width: '500px'}">			
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field p-col-12 p-md-12">
							<label for="descricao">Empresa</label>
							<Dropdown v-model.number="cnpjSelecionado"  :options="cnpjs" 
							optionLabel="razaoSocial" optionValue="id" placeholder="Selecione"/>
							<small class="p-invalid" v-if="enviandoForm && !cnpjSelecionado">Informe o CNPJ</small>
						</div>										
					</div>
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field p-col-12 p-md-12">
							<label for="descricao">Crachá do funcionário</label>
							<InputText id="descricao" v-model.trim="cracha" required="true" autocomplete="off"
								placeholder="Informe o crachá do funcionário" />
							<small class="p-invalid" v-if="enviandoForm && !cracha">Crachá</small>
						</div>	
					</div>	
					<div class="p-field-checkbox">
						<Checkbox id="binary" v-model="ehAdmin" :binary="true" />
						<label for="binary">Admin</label>
					</div>	
					<div class="p-fluid p-formgrid p-grid">	
						<div class="p-field p-col-12 p-md-12">
							<label for="descricao">Detalhes</label>
							<Textarea id="detalhes" v-model.trim="detalhes" rows="3" required="true" autocomplete="off"
							placeholder="Detalhes do celular" />
							<small class="p-invalid" v-if="enviandoForm && !detalhes">Detalhes</small>
						</div>	
					</div>					
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
						<Button label="Salvar" icon="pi pi-check" @click="criarUsuarioMobile"/>
					</template>
				</Dialog>

				<Dialog :visible.sync="exibirDialogEditar" header="Alterar Senha" :modal="true" class="p-fluid" :style="{width: '500px'}">			
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field p-col-12 p-md-12">
							<label for="descricao">Login do usuário</label>
							<InputText v-model="clienteAppSelecionado.login" readonly/>
						</div>										
					</div>								
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogEditar = false"/>
						<Button label="Gerar nova senha/código" icon="pi pi-check" @click="gerarNovaSenhaCodigo"/>
					</template>
				</Dialog>

				<Dialog :visible.sync="exibirDialogSucesso" header="Criar Usuário" :modal="true" class="p-fluid" :style="{width: '500px'}">			
					<div class="p-fluid p-formgrid p-grid">	
						<div class="p-field p-col-12 p-md-12 ">
							<Message severity="success" :closable="false" v-if="resposta.tipo === 'celular'">
								<p>Login do usuário: {{ resposta.login }}</p>
								<p>Código para alterar a senha: {{ resposta.codigoAlterarSenha }}</p>	
							</Message>
							<Message severity="success" :closable="false" v-else>
								<p>Login do usuário: {{ resposta.login }}</p>
								<p>Senha: {{ resposta.senha }}</p>	
							</Message>														
						</div>
					</div>
					<template slot="footer">
						<Button label="OK" icon="pi pi-check" @click="exibirDialogSucesso = false" />
					</template>
				</Dialog>

				<Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
					<div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
						Excluir dados de login do dispositivo?<br/><br/>
						<p>
							Tipo <b>{{ clienteAppSelecionado.clienteApp }}</b>
						</p>
						<p>						
							Login <b>{{ clienteAppSelecionado.login }}</b>
						</p>						
					</div>					
					<template #footer>
						<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="limparExcluir"/>
						<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
					</template>
				</Dialog>
				
			</div>
		</div>
	</div>
</template>

<script>
import ClienteAppService from '@/service/ClienteAppService';
import ClienteApp from '@/model/ClienteApp';
import Cnpj from '@/model/Cnpj';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';
export default {
	clienteAppService: null,
	data() {
		return {						
			permissaoNovo: false,
			permissaoEditar: false,
			permissaoExcluir: false,
			exibirDialogEditar: false,
			exibirDialogConfirmarExcluir: false,
			exibirDialogCadastroMobile: false,
			exibirDialogCadastroDeskTop: false,
			exibirDialogCadastro: false,
			exibirDialogSucesso: false,		
			enviandoForm: false,
			clienteAppSelecionado: {id:'',clienteApp:'', login:''},
			clientesApp:[],
			dispositivos:[],						
			dispositivoSelecionado: {nome: ''},
			filtro: {},
			cnpjs:[],
			idCnpjsSelecionado: null,
			cnpjSelecionado: new Cnpj(),
			detalhes: '',
			cracha: '',
			ehAdmin: false,
			resposta: {},
			items: [
				{
					label: 'Usuário Desktop',
					icon: 'pi pi-desktop',
					command: () => {					
						this.exibirDialogCadastroDeskTop = true;
						this.listarCnpjs();
					}
				},
				{
					label: 'Usuário Mobile',
					icon: 'pi pi-mobile',
					command: () => {
						this.exibirDialogCadastroMobile = true;
						this.listarCnpjs();
					}
				},
			]

		}
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao', 'getPermissoes']),
		listar(){
			let requisicao = {
				dispositivo: this.dispositivoSelecionado,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}	
			this.clienteAppService.listar(requisicao)
			.then(resp => {
				this.clientesApp = resp.data;
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		criarUsuarioDesktop() {
			this.enviandoForm = true;
			if(this.cnpjSelecionado != '' && this.detalhes != '') {
				let requisicao = {
					idCnpj: this.cnpjSelecionado,
					detalhes: this.detalhes,
					usuarioRequisicao: {...this.getDadosRequisicao()}
				}			
				this.clienteAppService.criarUsuarioDesktop(requisicao)
					.then(resp => {							
						this.fecharModal();
						this.listar();
						this.resposta = resp.data;						
						this.exibirDialogSucesso = true;						
					})
					.catch(erro => {exibirMensagem(this, erro)});
			}
		},
		criarUsuarioMobile() {
			this.enviandoForm = true;
			if(this.cnpjSelecionado != '' && this.detalhes != '') {
				let requisicao = {
					idCnpj: this.cnpjSelecionado,
					detalhes: this.detalhes,
					cracha: this.cracha,
					ehAdmin: this.ehAdmin,
					usuarioRequisicao: {...this.getDadosRequisicao()}
				}			
				this.clienteAppService.criarUsuarioMobile(requisicao)
					.then(resp => {							
						this.fecharModal();
						this.listar();
						this.resposta = resp.data;
						this.exibirDialogSucesso = true;				
					})
					.catch(erro => {exibirMensagem(this, erro)});
			}
		},
		gerarNovaSenhaCodigo() {
			let requisicao = {
					usuario: {...this.clienteAppSelecionado},
					usuarioRequisicao: {...this.getDadosRequisicao()}
				}			
				this.clienteAppService.gerarSenhaCodigo(requisicao)
					.then(resp => {							
						this.exibirDialogEditar = false;						
						this.resposta = resp.data;
						this.exibirDialogSucesso = true;				
					})
					.catch(erro => {exibirMensagem(this, erro)});
		},
		listarCnpjs() {
			this.clienteAppService.listarCnpjs({...this.getDadosRequisicao()})
			.then(resp => {
				this.cnpjs = resp.data;
			})
			.catch(erro => {exibirMensagem(this, erro)});
			
		},
		excluir() {
			let requisicao = {
				usuario: {...this.clienteAppSelecionado},
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.clienteAppService.excluir(requisicao)
				.then(resp => {	
					this.limparExcluir();		
					this.listar();
					exibirMensagem(this, resp);	
				})
				.catch(erro => {exibirMensagem(this, erro)});
		},
		limparExcluir() {
			this.clienteAppSelecionado = {
				clienteApp: '',
				nome: '',
				detalhes: '',
				login:'',
				dataUltimoRefresh: null
			};
			this.exibirDialogConfirmarExcluir = false;
		},
		editar(clienteApp) {
			this.clienteAppSelecionado = clienteApp;
			this.exibirDialogEditar = true;
		},
		confirmarExcluir(clienteApp) {
			this.clienteAppSelecionado = clienteApp;
			this.exibirDialogConfirmarExcluir = true;
		},
		fecharModal() {
			this.clienteAppSelecionado = new ClienteApp();
			this.exibirDialogCadastroDeskTop = false;
			this.exibirDialogCadastroMobile = false;
			this.cnpjs = [];
			this.detalhes = '';
			this.cracha = '';
			this.resposta = '';
			this.cnpjSelecionado = null;
			this.ehAdmin = false;
			this.enviandoForm = false;
		},
		carregarTipo(){
			this.dispositivos = [				
				{ name: 'Desktop', valor: 'Desktop' },
				{ name: 'Celular', valor: 'Celular' }
			]
		},
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(143);
			this.permissaoEditar = permissoes.includes(143);
			this.permissaoExcluir = permissoes.includes(144);			
		}
	},
	created() {
		this.clienteAppService = new ClienteAppService();
	},
	mounted() {
		this.validarPermissoes();
		this.carregarTipo();	
	}
}
</script>

<style scoped>
</style>